const firebaseConfig = {
    apiKey: "AIzaSyAK-PxJqJ_kp-i2NMAwvpwdc97D4tayPq4",
    authDomain: "plumb-perfect.firebaseapp.com",
    projectId: "plumb-perfect",
    storageBucket: "plumb-perfect.appspot.com",
    messagingSenderId: "515763893793",
    appId: "1:515763893793:web:0c67843d095b6f6aff5560"
  };
  export default firebaseConfig;